/** Canonical URL for the Becas Deportivas wizard on the landing site. */
export const BECAS_WIZARD_PATH = '/becas';

/** Path aliases that render the same wizard (SPA, no react-router). */
export const BECAS_WIZARD_PATHS = ['/becas', '/becas-deportivas'] as const;

export const BECAS_ACADEMY_SLUG = 'btalentstar';
